$(document).ready(function () {
  $(document).on('click', '.clients-momentum-planning-financing-component .financing-section-options-js .checkboxes__option', function () {
    // Update checkbox values back to financing section
    const component = $(this).closest('.clients-momentum-planning-financing-component');
    const id = component.attr('momentum_financing_section_id');
    const property = $(this).attr('attr');
    const checked = $(this).hasClass('checked');

    if (property === 'sba_robs' || property === 'self_funding') {
      const options = property === 'sba_robs' ? component.find('.sba-robs-options-js') : component.find('.self-funding-options-js');
      if (checked) {
        // Show options for SBA/ROBS or Self Funding, and update the value
        options.removeClass('d-none');
        const selectedValue = options.find('.radio-buttons__option.checked').attr('value');
        updateFinancingSection(id, property + '_option', selectedValue, component);
      } else {
        options.addClass('d-none');
        updateFinancingSection(id, property + '_option', null, component);
      }
    } else {
      updateFinancingSection(id, property, checked, component);
    }
  });

  // HIDE AND SHOW FINANCING PARTNER OPTIONS
  $(document).on('click', '.clients-momentum-planning-financing-component .financing-section-options-js .radio-buttons__option', function () {
    // Update radio button values back to financing section
    const component = $(this).closest('.clients-momentum-planning-financing-component');
    const id = component.attr('momentum_financing_section_id');
    const property = $(this).attr('attr');
    const value = $(this).attr('value');

    if (property === 'financing_partner') {
      component.find('.franfund-contact-options-js').addClass('d-none');
      component.find('.benetrend-contact-options-js').addClass('d-none');
      component.find('.first-financial-contact-options-js').addClass('d-none');

      if (value === 'franfund') {
        component.find('.franfund-contact-options-js').removeClass('d-none');
      }

      if (value === 'benetrends') {
        component.find('.benetrend-contact-options-js').removeClass('d-none');
      }

      if (value === 'first_financial') {
        component.find('.first-financial-contact-options-js').removeClass('d-none');
      }
    }

    updateFinancingSection(id, property, value, component);
  });

  // // CHANGE CONTACT EMAIL WHEN OPTION IS CLICKED
  $(document).on('click', '.clients-momentum-planning-financing-component .franfund-contact-options-js .radio-buttons__option', function () {
    updateContactEmail($(this).closest('.franfund-contact-options-js'), $(this).attr('value'));
    updateSchedulingLink($(this).closest('.franfund-contact-options-js'), $(this).attr('value'));
  });

  $(document).on('click', '.clients-momentum-planning-financing-component .benetrend-contact-options-js .radio-buttons__option', function () {
    updateContactEmail($(this).closest('.benetrend-contact-options-js'), $(this).attr('value'));
    updateSchedulingLink($(this).closest('.benetrend-contact-options-js'), $(this).attr('value'));
  });

  $(document).on('click', '.clients-momentum-planning-financing-component .first-financial-contact-options-js .radio-buttons__option', function () {
    updateContactEmail($(this).closest('.first-financial-contact-options-js'), $(this).attr('value'));
    updateSchedulingLink($(this).closest('.first-financial-contact-options-js'), $(this).attr('value'));
  });

  function updateContactEmail(radioOptions, value) {
    const email = radioOptions.find('.contact-email-js').attr('data-' + value);
    const emailATag = radioOptions.find('.contact-email-js a');
    emailATag.text(email);
    emailATag.attr('href', 'mailto:' + email);
  }

  function updateSchedulingLink(radioOptions, value) {
    const schedulingLink = radioOptions.find('.contact-scheduling-link-js').attr('data-' + value);
    const schedulingLinkATag = radioOptions.find('.contact-scheduling-link-js a');
    schedulingLinkATag.text(schedulingLink);
    schedulingLinkATag.attr('href', schedulingLink);
  }


  // UPDATE TEXT INPUT VALUES
  $(document).on('keyup', '.clients-momentum-planning-financing-component .input-text-box-js input', function () {
    const component = $(this).closest('.clients-momentum-planning-financing-component');
    const id = component.attr('momentum_financing_section_id');
    const property = $(this).attr('attr');
    const value = $(this).val();

    // Clear any existing timeout
    clearTimeout($(this).data('timeout'));

    // Set a timeout to update the value after 2 seconds
    $(this).data('timeout', setTimeout(function () {
      updateFinancingSection(id, property, value, component);
    }, 1000));
  });

  function updateFinancingSection(id, property, value, component) {
    $.post('/components/clients/momentum_sections/financing', {
      id: id,
      property: property,
      value: value
    }).done(function (data) {
      if (data.success) {
        window.reloadConfirmationDayReadinessAssessmentComponent();
        window.reloadMomentumSectionPlanningTab(data.section_completion_percentage, 'financing');
        window.reloadClientTaskBinComponents();
      }

      const momentum_tasks_component = component.find('.component.clients-momentum-task-bin-component').first()
      if (momentum_tasks_component.length > 0) {
        reloadComponent(momentum_tasks_component);
      }
    });
  }
});
